var _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.648438 33.839844 C 20.398438 33.839844 20.148438 33.75 19.949219 33.570312 C 19.519531 33.183594 19.484375 32.523438 19.871094 32.097656 L 27.136719 23.996094 L 19.871094 15.90625 C 19.484375 15.476562 19.519531 14.816406 19.949219 14.433594 C 20.378906 14.046875 21.039062 14.082031 21.425781 14.511719 L 29.941406 24 L 21.425781 33.492188 C 21.21875 33.722656 20.933594 33.839844 20.648438 33.839844 Z M 20.648438 33.839844 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.9c570522a4faeca7647ede6f5085ebe7.svg";
export { ForwardRef as ReactComponent };